import { styled, Box, media } from '@creditas-ui/react';

const Brand = styled(Box)`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.down('4xl')} {
    position: relative;
    margin: 0 auto;
  }
`;

export { Brand };
